import { LayoutDashboard, BarChart3, ClipboardList, FileText, Layers, Boxes, Files } from 'lucide-react'
import { withIcon3D } from '@/components/icons3d/Icon3D'

/** The task destinations shared by the sidebar and phone navigation. */
export const workspaceNavigation = [
  { path: '/dashboards', label: 'Dashboards', icon: withIcon3D('dashboards', LayoutDashboard), assist: 'nav.dashboards' },
  {
    path: '/metrics', label: 'Metrics', icon: withIcon3D('metrics', BarChart3), assist: 'nav.metrics',
    relatedPaths: ['/categories', '/partitions'],
    children: [
      { path: '/categories', label: 'Categories', icon: withIcon3D('categories', Layers) },
      { path: '/partitions', label: 'Partition types', icon: withIcon3D('partitions', Boxes) },
    ],
  },
  { path: '/data-entry', label: 'Data entry', icon: withIcon3D('data-entry', ClipboardList), assist: 'nav.data_entry' },
  {
    path: '/reports', label: 'Reports', icon: withIcon3D('reports', FileText), assist: 'nav.reports',
    relatedPaths: ['/report-templates'],
    children: [{ path: '/report-templates', label: 'PDF templates', icon: withIcon3D('templates', Files) }],
  },
]

export function matchesNavigationPath(pathname, path) {
  return pathname === path || pathname.startsWith(`${path}/`)
}

export function isNavigationItemActive(pathname, item) {
  return [item.path, ...(item.relatedPaths || [])].some((path) => matchesNavigationPath(pathname, path))
}
